const defaultOptions = {
  context: {},
  feedbackType: 'general_feedback',
  promptLocation: 'manual',
};

export function openFeedbackPrompt(options = {}) {
  window.dispatchEvent(new CustomEvent('v3me:feedback-prompt', {
    detail: {
      ...defaultOptions,
      ...options,
      context: {
        ...defaultOptions.context,
        ...(options.context || {}),
      },
    },
  }));
}

export function openFeatureFeedbackPrompt(options = {}) {
  openFeedbackPrompt({
    ...options,
    feedbackType: 'feature_feedback',
  });
}

export function openBugReportPrompt(options = {}) {
  openFeedbackPrompt({
    ...options,
    feedbackType: 'bug_report',
  });
}

export function openGeneralFeedbackPrompt(options = {}) {
  openFeedbackPrompt({
    ...options,
    feedbackType: 'general_feedback',
  });
}
